import * as React from "react";

function ZoomOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M14 5a9 9 0 100 18 9 9 0 000-18zM3 14C3 7.925 7.925 3 14 3c6.074 0 11 4.925 11 11 0 2.678-.957 5.132-2.548 7.04l6.255 6.255-1.414 1.414-6.255-6.255A10.955 10.955 0 0114 25C7.925 25 3 20.074 3 14zm7 1h8v-2h-8v2z",
    clipRule: "evenodd"
  }));
}

export default ZoomOutIcon;